module.exports = __webpack_public_path__ + "img/consulting.57e7a442.jpg";